import React from 'react'
import { Row } from 'react-bootstrap'
import Nav from 'react-bootstrap/Nav'


import '../styles/rrss.styles.scss'

// Iconos
import { FaFacebook, FaInstagramSquare, FaYoutube } from "react-icons/fa";

const RRSS = ({size, align}) => {
    const iconSize = size ? Number(size) + 6 : 22

    return (
        <Row className={align}>
            <Nav.Link 
                href='https://www.facebook.com/lavidaenrojoasociacion' 
                target="_blank"
                className='rrss-icon p-0 mr-1'
            >
                <FaFacebook size={iconSize} />
            </Nav.Link>
            <Nav.Link 
                href='https://www.instagram.com/lavidaenrojo_asociacion/' 
                target="_blank"
                className='rrss-icon p-0 mr-1'
            >
                <FaInstagramSquare size={iconSize} />
            </Nav.Link>
            <Nav.Link 
                href='https://www.youtube.com/@lavidaenrojo_asociacion' 
                target="_blank"
                className='rrss-icon p-0 mr-1'
                aria-label='YouTube'
            >
                <FaYoutube size={iconSize} />
            </Nav.Link>
            {/**<Nav.Link 
                href='https://www.instagram.com/espaciomatriz/' 
                target="_blank" 
                className='rrss-icon p-0 mr-2'
            >
                <FaTelegram size={size} />
            </Nav.Link>*/}
        </Row>
    )
}

export default RRSS